export default [
  {
    path: "/login",
    component: () => import("./components/login"),
    meta: { hideNavigation: true },
  },
  {
    path: "/",
    component: () => import("./components/homepage/dashboard"),
    beforeEnter: guardMyroute,
    children: [
      { path: "/notification", component: () => import("./views/pusher") },
      {
        path: "/",
        component: () => import("./components/home-content"),
        meta: { showCustomerSearch: true },
      },
      // rentals routes
      {
        path: "/bookings/new",
        component: () => import("./components/rental/booking/new"),
      },
      {
        path: "/bookings/plus",
        component: () => import("./components/rental/booking/plus"),
      },
      {
        path: "/bookings/expired",
        component: () => import("./components/rental/booking/expired"),
      },
      {
        path: "/bookings/failed",
        component: () => import("./components/rental/booking/failed"),
      },
      {
        path: "/bookings/drop",
        component: () => import("./components/rental/booking/drop"),
      },
      {
        path: "/bookings/extension/failed",
        component: () => import("./components/rental/booking/extensionFailed"),
      },
      // **** rentals routes end ****

      // customer routes start
      {
        path: "/customers/waitlist",
        component: () => import("./components/rental/customer/waitlist"),
      },
      {
        path: "/customers/new",
        component: () => import("./components/rental/customer/new"),
      },
      {
        path: "/customers/search",
        component: () => import("./components/rental/customer/search"),
      },
      {
        path: "/customers/payment/retrieval/create",
        component: () =>
          import("./components/rental/customer/payment/retrieval/create"),
      },
      {
        path: "/customers/payment/retrieval/home",
        component: () =>
          import("./components/rental/customer/payment/retrieval/home"),
      },
      {
        path: "/customers/payment/retrieval/view/:id",
        component: () =>
          import("./components/rental/customer/payment/retrieval/view"),
      },
      // ****  customer routes ends ****

      // finance routes
      {
        path: "/finance/idfc/homepage",
        component: () => import("./components/finance/idfc/homepage"),
      },
      {
        path: "/update/application/:id",
        component: () => import("./components/finance/idfc/updateForm"),
      },
      // **** finance routes end *****

      // recovery routes
      {
        path: "/operations/recovery",
        component: () => import("./components/rental/operations/recovery"),
      },
      {
        path: "/operations/traffic-violation",
        component: () =>
          import("./components/rental/operations/checkTrafficViolation"),
      },
      // **** recovery routes end *****

      // tools routes
      {
        path: "/tools/templates/home",
        component: () => import("./components/tools/templates/home"),
      },
      {
        path: "/tools/calculator",
        component: () => import("./components/reusuable/paymentCalculator"),
      },
      {
        path: "/tools/knowlarity/call/missed",
        component: () => import("./components/knowlarity/missed_call"),
      },
      {
        path: "/tools/knowlarity/call/incoming",
        component: () => import("./components/knowlarity/incoming_call"),
      },

      // **** tools routes end *****

      // feeds
      {
        path: "/feeds",
        component: () => import("./views/feeds"),
      },
      // feeds end
      {
        path: "/userProfile/:cx_id/:phone",
        component: () => import("./components/user/home"),
        children: [
          {
            path: "/",
            component: () => import("./components/user/views/booking/history"),
          },
          {
            path: "penalty&points",
            component: () => import("./components/user/views/penalty&points"),
          },
          {
            path: "bookingHistory",
            component: () => import("./components/user/views/booking/history"),
          },
          {
            path: "documents",
            component: () => import("./components/user/views/documents"),
          },
          {
            path: "activities",
            component: () => import("./components/user/views/activities"),
          },
          {
            path: "support",
            component: () => import("./components/user/views/support"),
          },
          {
            path: "waitlistHistory",
            component: () => import("./components/user/views/waitlistHistory"),
          },
          {
            path: "couponHistory",
            component: () => import("./components/user/views/couponHistory"),
          },
          {
            path: "collectionHistory",
            component: () =>
              import("./components/user/views/collectionHistory"),
          },
          {
            path: "knowlarity-support",
            component: () =>
              import("./components/user/views/knowlarityHistory"),
          },
        ],
      },
      // user agents
      {
        path: "/userAgents",
        component: () => import("./components/userAgent/allAgents"),
      },
      // release note
      {
        path: "/releaseNote",
        component: () => import("./views/releaseNote"),
      },
      {
        path: "/user/agent",
        component: () => import("./components/userAgent/home"),
        children: [
          {
            path: 'profile',
            component: () => import("./components/userAgent/views/profile"),
          },
          {
            path: 'activities/recent',
            component: () => import("./components/userAgent/views/recentActivities"),
          },
          {
            path: 'settings',
            component: () => import("./components/userAgent/views/settings"),
          }
        ]
      },
      // 404
      //otpoints
      {
        path: 'rewards',
        component: ()=> import('./components/otpoints/Otpoints')
      },
      {
        path:'rewards/customer/:id',
        component:()=>import('./components/otpoints/OtPointsUser')
      }
    ],
  },
  {
    path: "*",
    component: () => import("./components/404/progress"),
  },
];
function guardMyroute(to, from, next) {
  var isAuthenticated = localStorage.getItem("userData");
  if (isAuthenticated) {
    next(); // allow to enter route
  } else {
    next("/login"); // go to '/login';
  }
}
